import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { logout } from './AuthSlice'
const apiURL = process.env.REACT_APP_BACKEND

const initialState = {
  gates: [],
}


export const getGates = createAsyncThunk('gate/getGates', async (_, thunkAPI) => {
  // access the entire redux state
  const state = thunkAPI.getState()
  const { authId, webToken, subscriberId, customerId, gateId } = state.auth

  let gateURL;
  if (authId === 100) {
    gateURL = 'api/gatesNew/'
  } else if (authId === 1) {
    gateURL = 'api/gatesNew/subscriber/' + subscriberId;
  } else if (authId === 2 || authId === 4) {
    gateURL = 'api/gatesNew/customer/' + customerId;
  } else {
    // this is a guard, so let's get only the gate it is assigned to
    gateURL = 'api/gatesNew/id/' + gateId;
  }

  return await fetch(apiURL + gateURL, {
    method: 'get',
    headers: { 'Accept': 'application/json', 'Authorization': webToken },
    credentials: 'include'
  })
  .then(response => response.json())
  // a real (even empty) result is an array; a bad/error shape -> null so the reducer keeps the
  // last-known counts instead of blanking the On-site pills to a false "nobody on-site".
  .then(data => (data && Array.isArray(data.rows)) ? data.rows : null)
  .catch(error => {
      console.error('Error:', error);
      return null
  })
});

const gateSlice = createSlice({
  name: 'gate',
  initialState,
  reducers: {
    setGateState: (state, action) => {
      state[action.payload.field] = action.payload.value
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGates.fulfilled, (state, action) => {
        // keep the last-known gates/counts if the fetch failed (payload null) — a failed on-site
        // poll must not erase occupancy into a false "nobody on-site".
        if (action.payload) state.gates = action.payload
      })
      .addCase(logout, (state, action) => {
        return { ...initialState }
      })
  },
})

export const { setGateState } = gateSlice.actions
export default gateSlice.reducer
